"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTxMsgStakeAuthorization = void 0;
const proto_1 = require("@tharsis/proto");
function createTxMsgStakeAuthorization(chain, sender, fee, memo, params) {
    const msgStakeGrant = (0, proto_1.createStakeAuthorization)(params.validator_address, params.denom, params.maxTokens, proto_1.stakeAuthTypes.AUTHORIZATION_TYPE_DELEGATE);
    const msgCosmos = (0, proto_1.createMsgGrant)(sender.accountAddress, params.bot_address, msgStakeGrant, params.duration_in_seconds);
    const tx = (0, proto_1.createTransaction)(msgCosmos, memo, fee.amount, fee.denom, parseInt(fee.gas, 10), 'ethsecp256', sender.pubkey, sender.sequence, sender.accountNumber, chain.cosmosChainId);
    return {
        signDirect: tx.signDirect,
        legacyAmino: tx.legacyAmino,
    };
}
exports.createTxMsgStakeAuthorization = createTxMsgStakeAuthorization;
//# sourceMappingURL=grant.js.map